import { useState } from 'react';

import MroCatalogTree from './components/MroCatalogTree';
import MroSubCatalogList from './components/MroSubCatalogList';

const MroCatalogContent = (props) => {
  const { resourceData, catalogCount, catalogListData, catalogData } = props;
  const [activeTab, setActiveTab] = useState(0);

  const catalogName = [
    { title: '工业品', url: `${resourceData?.projectConfigVO?.lcscWwwUrl}/mro.html`, spm: '2' },
    { title: '电子元器件', url: `${resourceData?.projectConfigVO?.lcscWwwUrl}/catalog.html`, spm: '1' },
  ];

  return (
    <div className="w-[100%] p-[20px]">
      <nav aria-label="产品分类导航" data-spm="nav">
        <ul className="flex items-center gap-8 border-b border-[#f0f0f0] border-solid " role="tablist">
          {catalogName.map((item, index) => (
            <li key={index} role="presentation">
              <a
                href={item.url}
                role="tab"
                aria-selected={activeTab === index}
                aria-label={`${item.title}分类`}
                data-spm={item.spm}
                className={`
                  inline-block pb-3 text-[18px] transition-colors relative font-semibold
                  ${activeTab === index ? 'text-[#0093e6]' : 'text-[#333] hover:text-[#0093e6]'}
                `}
                onClick={(e) => {
                  if (index === activeTab) {
                    e.preventDefault();
                  }
                  setActiveTab(index);
                }}
              >
                {item.title}
                {activeTab === index && (
                  <span className="absolute bottom-0 left-0 right-0 h-[5px] bg-[#0093e6]" aria-hidden="true" />
                )}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <div className="flex mt-[20px] w-full">
        <MroCatalogTree catalogListData={catalogListData} />
        {!!catalogListData?.length && (
          <MroSubCatalogList
            catalogListData={catalogListData}
            catalogCount={catalogCount}
            resourceData={resourceData}
            catalogData={catalogData}
          />
        )}
      </div>
    </div>
  );
};

export default MroCatalogContent;
